module.exports = __webpack_public_path__ + "media/img/pages/companies/adnovum-908b156ba9431df84ad54d569ee6101b.png";